import {
  DIAS_PRESTAMO_SUGERIDOS,
  diasEntre,
  hoyAr,
  MODOS_ENTREGA,
  plazoElegido,
  sumarDias,
  textoVence,
} from "../../shared/herramientas";

/* ASIGNAR O PRESTAR (Nico, 06/10).
 *
 * *«Cuando da una herramienta, un toggle que por defecto está en Asignar (la
 * herramienta queda asignada a la persona, sin plazo de devolución). Al
 * pasarlo a Prestar aparece un campo para poner cuántos días la presta o la
 * fecha en que la tiene que devolver.»*
 *
 * Los días y la fecha son DOS FORMAS DE DECIR LO MISMO y se mueven juntos:
 * tipear «3» pone la fecha de dentro de tres días, y elegir una fecha pone
 * cuántos días son. Abajo se lee en castellano qué quedó: «la tiene que
 * devolver el vie 10/10». Lo que se guarda lo decide `plazoElegido`.
 */

export const plazoInicial = () => ({ modo: "asignar", dias: "", fecha: "" });

export default function AsignarOPrestar({ valor, onCambiar, plural = false, ahora }) {
  const v = valor || plazoInicial();
  const hoy = hoyAr(ahora);

  const elegirModo = (modo) => {
    if (modo === v.modo) return;
    if (modo === "prestar" && !v.dias && !v.fecha) {
      const d = DIAS_PRESTAMO_SUGERIDOS;
      onCambiar({ modo, dias: String(d), fecha: sumarDias(hoy, d) });
    } else {
      onCambiar({ ...v, modo });
    }
  };
  const cambiarDias = (txt) => {
    const d = Number(txt);
    onCambiar({ ...v, dias: txt,
                fecha: Number.isInteger(d) && d >= 1 ? sumarDias(hoy, d) : "" });
  };
  const cambiarFecha = (f) => {
    const n = diasEntre(hoy, f);
    onCambiar({ ...v, fecha: f, dias: n !== null && n >= 1 ? String(n) : "" });
  };

  const pl = plazoElegido(v, ahora);

  return (
    <div className="hrr-modo">
      <div className="hrr-modo-toggle" role="group" aria-label="Asignar o prestar">
        {Object.entries(MODOS_ENTREGA).map(([k, m]) => (
          <button key={k} type="button" className="hrr-chip"
                  aria-pressed={v.modo === k} onClick={() => elegirModo(k)}>
            {m.rotulo}
          </button>
        ))}
      </div>
      {v.modo === "asignar" && (
        <p className="tenue hrr-modo-ayuda">
          Queda{plural ? "n" : ""} para la persona, sin fecha de devolución.
        </p>
      )}
      {v.modo === "prestar" && (
        <>
          <div className="hrr-modo-plazo">
            <label className="hrr-campo">
              Por cuántos días
              <input type="number" min={1} max={365} inputMode="numeric"
                     value={v.dias} aria-label="Días de préstamo"
                     onChange={(e) => cambiarDias(e.target.value)} />
            </label>
            <span className="tenue hrr-modo-o">o</span>
            <label className="hrr-campo">
              Hasta el
              <input type="date" min={hoy} value={v.fecha}
                     aria-label="Fecha de devolución"
                     onChange={(e) => cambiarFecha(e.target.value)} />
            </label>
          </div>
          <p className={pl.ok ? "hrr-modo-ayuda" : "hrr-modo-ayuda hrr-modo-error"} role="status">
            {pl.ok
              ? `${plural ? "Las tiene" : "La tiene"} que devolver ${textoVence(pl.vence, ahora)}. ` +
                `El bot le avisa la víspera y ese día.`
              : pl.error}
          </p>
        </>
      )}
    </div>
  );
}
